<template>
  <div class="app-container">
    <header class="header">
      <h1>海关申报业务管理系统</h1>
    </header>
    <div class="content-wrapper">
      <nav class="sidebar">
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical-demo"
          @select="handleMenuSelect"
          background-color="#fff"
          text-color="#333"
          active-text-color="#1890ff">
          <el-menu-item index="/goods-code">
            <span>商品编码管理</span>
          </el-menu-item>
          <el-menu-item index="/goods-code-collection">
            <span>商品编码采集</span>
          </el-menu-item>
          <el-menu-item index="/base-param">
            <span>基础参数管理</span>
          </el-menu-item>
          <el-menu-item index="/base-param-collection">
            <span>基础参数采集</span>
          </el-menu-item>
        </el-menu>
      </nav>
      <main class="content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeMenu: '/goods-code'
    }
  },
  watch: {
    $route: {
      handler(to) {
        this.activeMenu = to.path
      },
      immediate: true
    }
  },
  methods: {
    handleMenuSelect(key) {
      if (this.$route.path !== key) {
        this.$router.push(key)
      }
    }
  }
}
</script>

<style>
.header {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-active) 100%);
  color: white;
  padding: 0 24px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}

.header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.4;
  pointer-events: none;
}

.header h1 {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  letter-spacing: 2px;
  position: relative;
  z-index: 1;
}

.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.sidebar {
  width: 220px;
  background-color: #fff;
  border-right: 1px solid #e8e8e8;
  flex-shrink: 0;
  height: 100%;
  overflow-y: auto;
}

.content {
  flex: 1;
  overflow-y: auto;
  height: 100%;
  background-color: #f0f2f5;
  padding: 24px;
}

.el-menu-vertical-demo {
  border-right: none;
  height: 100%;
  padding: 12px 8px;
}

.el-menu-item {
  height: 48px;
  line-height: 48px;
  margin: 4px 0;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.el-menu-item:hover {
  background-color: rgba(24, 144, 255, 0.08) !important;
}

.el-menu-item.is-active {
  background-color: #e6f7ff !important;
  border-right: 3px solid #1890ff;
  font-weight: 500;
}

.el-menu-item .icon {
  margin-right: 10px;
  font-size: 16px;
}
</style>